<template>
  <router-link :to="redirectTo" class="product-preview hover-shadow">
    <div class="md:p-2 h-full flex items-center">
      <div class="img-box">
        <img :src="productImage" class="product-img">
      </div>
      <div class="detail-box">
        <p class="detail-box-name">{{ product.name }}</p>
        <div v-if="product.stockInUsa" class="flex">
          <img src="@/assets/icons/usa.svg" class="flag">
          <div class="pl-2 pt-1 text-xs">Stock in USA</div>
        </div>
        <p
          v-if="product.displayMoq"
          class="detail-box-moq"
        >
          MOQ: {{ product.displayMoq }}
        </p>
        <div class="detail-box-price">{{ product.price }}</div>
        <div class="hidden md:block pt-4 h-12">
          <button
            class="px-6 bg-blue rounded-lg text-white py-1"
            @click.prevent="addToCart(product.id)"
          >
            Add to cart
          </button>
        </div>
      </div>
    </div>
  </router-link>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProductPreviewInList',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters ([
      'isUserLoggedIn'
    ]),
    productImage() {
      return this.product.image ? this.product.image : this.product.images[0]
    },
    rating() {
      return this.product.supplierRating ? this.product.supplierRating : this.product.supplier.rating
    },
    redirectTo() {
      return this.product.slug ? `/${this.product.slug}` : `/products/${this.product.id}`
    }
  },
  methods: {
    ...mapActions ([
      'getProductInfo',
      'addItemToCart'
    ]),
    async addToCart() {
      const product = await this.getProductInfo(this.product.id)
      product.inco_terms = product.incoTerms[0]
      product.quantity = product.minimumOrderQuantity
      const status = await this.addItemToCart(product)
      const msg = status === 'Added' ? 'Product added to cart' : 'Product quantity updated in cart'
      this.$notify({
        group: 'buyHive',
        type: 'success',
        text: msg
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .product-preview {
    @apply block border rounded mb-2;
    .img-box {
      @apply h-40 w-2/5 py-2;
      @screen md { @apply w-1/5 }
      .product-img { @apply mx-auto h-auto w-auto max-h-full }
    }
    .detail-box {
      @apply pl-6 pr-2 w-3/5;
      @screen md { @apply w-4/5 }
      &-name { @apply capitalize pb-1; }
      &-moq { @apply text-sm opacity-50; }
      &-price { @apply pt-2 tracking-tighter text-lg font-semibold; }
      .flag { @apply w-8; }
    }
  }
</style>
